module.exports = __webpack_public_path__ + "img/Banner-Image.2da5163d.jpg";